<template>
  <span class="invalid-feedback" v-if="errorMessage" v-html="errorMessage"></span>
</template>

<script>
export default {
  name: "FormInputError",

  props: {
    errorMessage: {
      type: String,
      default: ''
    }
  },
}
</script>
